import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ApprovalsInbox from './ApprovalsInbox';

export default function ApprovalsRoutes() {
  return (
    <Routes>
      <Route index element={<ApprovalsInbox />} />
    </Routes>
  );
}
